'use strict';

module.exports = require('./Text');